<!--Loader-->
<div *ngIf="isLoading" class="ui active inverted dimmer">
    <div class="ui loader"></div>
</div>

<form #form="ngForm" *ngIf="automatedEmailSettings" autocomplete="off">
    <div class="app-grid">
        <!-- Default value for mat select is not set if the options are still being retrieved -->
        <!-- We will only render this after loading is completing so all options are already retrieved and the default can be selected-->
        <mat-form-field *ngIf="!isLoading" class="columns-12">
            <mat-label appRemoveAriaOwns>{{
                'applicant-tracker.components.automated-email-settings.from' | appTranslate
            }}</mat-label>
            <mat-select
                required
                placeholder="{{
                    'applicant-tracker.components.automated-email-settings.selectReplyEmail' | appTranslate
                }}"
                name="replyTo"
                #replyTo="ngModel"
                [(ngModel)]="automatedEmailSettings.replyTo"
            >
                <mat-option *ngIf="previousUserEmail" [value]="previousUserEmail">{{ previousUserEmail }}</mat-option>
                <mat-option [value]="userEmail">{{ userEmail }}</mat-option>
                <mat-option [value]="noReplyEmail"> {{ noReplyEmail }} </mat-option>
            </mat-select>
            <mat-error *ngIf="replyTo.invalid">{{ replyTo.errors | formErrors }}</mat-error>
        </mat-form-field>
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{
                'applicant-tracker.components.automated-email-settings.template' | appTranslate
            }}</mat-label>
            <mat-select name="templateId" [(ngModel)]="templateId" (selectionChange)="onTemplateIdChange()">
                <mat-option value="free-form">{{
                    'applicant-tracker.components.automated-email-settings.freeForm' | appTranslate
                }}</mat-option>
                <mat-option *ngFor="let template of applicantMessageTemplates" [value]="template.id">{{
                    template.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="columns-12">
            <mat-label>{{ 'applicant-tracker.components.automated-email-settings.subject' | appTranslate }}</mat-label>
            <input
                type="text"
                required
                name="subject"
                [(ngModel)]="automatedEmailSettings.subject"
                #subject="ngModel"
                matInput
            />
            <mat-error *ngIf="subject.invalid">{{
                'applicant-tracker.components.automated-email-settings.pleaseProvideAValidSubject' | appTranslate
            }}</mat-error>
        </mat-form-field>
        <mat-form-field class="columns-12">
            <mat-label>{{ 'applicant-tracker.components.automated-email-settings.body' | appTranslate }}</mat-label>
            <ui-rich-text
                name="body"
                required
                #body="ngModel"
                [(ngModel)]="automatedEmailSettings.body"
                [stripNewlines]="true"
            ></ui-rich-text>
        </mat-form-field>
    </div>
</form>
